import React from 'react';
import {HStack, View} from "native-base";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import AppText from "./AppText";
import {GlobalConsts} from "../../styles/GlobalConsts";
import {t} from "../../services/i18n";
import {GlobalStyleAttributes} from "../../styles/GlobalStyles";
import {IconSwitcher} from "../Icons8Generator/IconSwitcher";
import CustomButtonV2 from "./CustomButtonV2";

const CustomButtonExtended = (props) => {
    const {
        title,
        fontSize,
        iconName,
        onPress,
        leftSideExtras,
        mainColor,
        bgColor,
        iconColor,
        iconReplacement,
        iconPrefix,
        iconSize,
        boldFont,
        mediumFont,
        order,
        iconWidth,
        leftStyles,
        rightStyles,
        textStyles,
        hasLock,
        LockElement,
        buttonId,
        space,
        iconStyle,
        ...rest} = props;
    let iconNameOverride = null;
    iconNameOverride = IconSwitcher(iconPrefix || GlobalConsts.iconPrefix.LIGHT, iconName)

    return (
        <CustomButtonV2 onClick={onPress}
             style={{width: '100%', order: order }}
             id={buttonId}
             override={({color}) => (
            <HStack bg={bgColor} justifyContent={'space-between'} alignItems={'center'} w={'100%'} borderRadius={'4px'} opacity={hasLock ? 0.5 : 1} {...rest}>
                <HStack p={'10px'} justifyContent={'space-between'} space={space || '0.5rem'} alignItems={'center'} {...leftStyles}>
                    {iconName &&
                    <View w={iconWidth ? iconWidth : '1.5rem'} style={iconStyle}>
                        <FontAwesomeIcon icon={iconNameOverride ? iconNameOverride : `${iconPrefix || GlobalConsts.iconPrefix.LIGHT} ${iconName}`} fontSize={iconSize} color={iconColor || color}/>
                    </View>}
                    <>{iconReplacement}</>
                    <AppText style={[{color: mainColor, fontSize: fontSize || GlobalStyleAttributes.fonts.infoText}, textStyles]} boldFont={boldFont} mediumFont={mediumFont} hoverColor={color}>{t(title)}</AppText>
                    {hasLock && (LockElement || <FontAwesomeIcon icon={'fa-light fa-lock-keyhole'}/>)}
                </HStack>
                {
                    leftSideExtras &&
                    <HStack justifyContent={'center'} mx={'0.5rem'} space={'5px'} {...rightStyles}>
                        {leftSideExtras}
                    </HStack>
                }
            </HStack>)}
        />
    );
};

export default CustomButtonExtended;

